// src/App.js
import React, { useState } from 'react';
import UpdateSeatInfo from './UpdateSeatInfo';
import GetSeatInfo from './GetSeatInfo';
import OngoingIssues from './OngoingIssues';
import Log from './Log';
import Modal from './Modal';
import AuthModal from './AuthModal';
import Notification from './Notification';
import './styles.css';

function App() {
  const [modal, setModal] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [notification, setNotification] = useState({ message: '', type: '' });

  const closeModal = () => setModal('');

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
  };

  const clearNotification = () => {
    setNotification({ message: '', type: '' });
  };

  if (!isAuthenticated) {
    return <AuthModal onAuthenticate={setIsAuthenticated} showNotification={showNotification} />;
  }

  return (
    <div className="app-container">
      <h1>Theater Seat Logger</h1>
      <div className="button-container">
        <button onClick={() => setModal('updateSeatInfo')}>Update Seat Info</button>
        <button onClick={() => setModal('getSeatInfo')}>Get Seat Info</button>
        <button onClick={() => setModal('ongoingIssues')}>Ongoing Issues</button>
        <button onClick={() => setModal('log')}>Log</button>
      </div>

      {modal === 'updateSeatInfo' && (
        <Modal closeModal={closeModal}>
          <UpdateSeatInfo closeModal={closeModal} showNotification={showNotification} />
        </Modal>
      )}

      {modal === 'getSeatInfo' && (
        <Modal closeModal={closeModal}>
          <GetSeatInfo closeModal={closeModal} showNotification={showNotification} />
        </Modal>
      )}

      {modal === 'ongoingIssues' && (
        <Modal closeModal={closeModal}>
          <OngoingIssues closeModal={closeModal} showNotification={showNotification} />
        </Modal>
      )}

      {modal === 'log' && (
        <Modal closeModal={closeModal}>
          <Log closeModal={closeModal} showNotification={showNotification} />
        </Modal>
      )}

      <Notification
        message={notification.message}
        type={notification.type}
        onClose={clearNotification}
      />
    </div>
  );
}

export default App;
